import React from 'react'
import { LearningItem } from '../../models/LearningItem'
import styles from './CoursePage.module.scss'
import ProgressBar from '../../components/basics/ProgressBar/ProgressBar'
import { useTranslation } from 'react-i18next'

export default React.memo(function CourseActivity({ learningItem }: { learningItem: LearningItem }) {
  const { t } = useTranslation()

  if (learningItem.learningProgress && learningItem.learningProgress.firstAccessedAt) {
    return (
      <div className={styles.currentUserActivity}>
        <ProgressBar circular progress={learningItem.learningProgress.completionPercentage || 0} />
        {learningItem.kind !== 'learningPath' && (
          <div>{t(`learning_assignments.participants_details.status ${learningItem.currentUserStatus}`)}</div>
        )}
      </div>
    )
  }

  return <span></span>
})
